module.exports = __webpack_public_path__ + "img/stance1.46d9125f.png";